import PropTypes from 'prop-types';
import { Component } from 'react';

import InputBookmarkedUsers from 'hb-react/frontoffice/components/inputs/InputBookmarkedUsers';
import InputLocation from 'hb-react/frontoffice/components/inputs/InputLocation';
import InputsCustomAttributes from 'hb-react/frontoffice/components/inputs/InputsCustomAttributes';
import SelectCitizenships from 'hb-react/shared/components/select2/SelectCitizenships';
import SelectCompanies from 'hb-react/shared/components/select2/SelectCompanies';
import SelectIndustries from 'hb-react/shared/components/select2/SelectIndustries';
import SelectSchools from 'hb-react/shared/components/select2/SelectSchools';
import SelectSkills from 'hb-react/shared/components/select2/SelectSkills';
import SelectSubnetworks from 'hb-react/shared/components/select2/SelectSubnetworks';
import { useQueryNationalities } from 'hb-react/shared/hooks/useQueryNationalities';
import * as mobileDeviceFromUserAgent from 'helpers/mobileDeviceFromUserAgent';

class TargetingFilters extends Component {
  componentDidMount() {
    const { searchOnInit, triggerSearch } = this.props;

    if (searchOnInit) {
      triggerSearch();
    }
  }

  handleSubmit = (event) => {
    const { triggerSearch } = this.props;

    if (event && event.constructor === Event.constructor) {
      event.preventDefault();
    }
    triggerSearch(true);
  };

  render() {
    const { nationalityOptions } = this.props;

    return (
      <form className="js-targeting-form" onSubmit={this.handleSubmit}>
        {AlumniConnect.currentNetwork?.network_config
          ?.user_bookmarks_enabled && (
          <InputBookmarkedUsers onChange={this.handleSubmit} />
        )}
        {mobileDeviceFromUserAgent.any() && (
          <input
            className="push-half--bottom"
            type="search"
            name="query[who]"
            placeholder={I18n.t('layouts.search_for_a_name')}
            autoComplete="off"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                this.handleSubmit();
              }
            }}
          />
        )}
        <InputLocation
          inputName="query"
          primaryInputName="where"
          onSelectLocation={this.handleSubmit}
          defaultLocation={{}}
          radius={{ enabled: true, inputName: 'query[distance]' }}
        />
        <SelectCompanies
          name="query[company_ids][]"
          multiple
          onChange={this.handleSubmit}
          allowUpdate={false}
        />
        <SelectSchools
          name="query[school_ids][]"
          placeholder={
            AlumniConnect.currentNetwork?.user_fields_config
              ?.educations_school_name_placeholder
          }
          networkId={AlumniConnect.currentNetwork?.id}
          multiple
          onChange={this.handleSubmit}
          allowUpdate={false}
        />
        {AlumniConnect.currentNetwork?.user_fields_config
          ?.display_industries && (
          <SelectIndustries
            name="query[industry_ids][]"
            placeholder={
              AlumniConnect.currentNetwork?.user_fields_config
                ?.industries_placeholder
            }
            multiple
            onChange={this.handleSubmit}
            allowUpdate={false}
          />
        )}
        {AlumniConnect.currentNetwork?.['searchable_skills?'] && (
          <SelectSkills
            name="query[skill_ids][]"
            placeholder={
              AlumniConnect.currentNetwork?.user_fields_config
                ?.skills_placeholder
            }
            multiple
            onChange={this.handleSubmit}
            allowUpdate={false}
          />
        )}
        <SelectSubnetworks
          name="query[sub_network_ids][]"
          placeholder={
            AlumniConnect.currentNetwork?.user_fields_config
              ?.sub_networks_placeholder
          }
          multiple
          onChange={this.handleSubmit}
          allowUpdate={false}
        />
        {AlumniConnect.currentNetwork?.['searchable_nationalities?'] &&
          AlumniConnect.currentNetwork?.user_fields_config
            ?.display_nationalities && (
            <SelectCitizenships
              name="query[nationality_ids][]"
              citizenships={nationalityOptions}
              placeholder={
                AlumniConnect.currentNetwork?.user_fields_config
                  ?.nationalities_placeholder
              }
              multiple
              onChange={this.handleSubmit}
              allowUpdate={false}
            />
          )}
        <InputsCustomAttributes onChange={this.handleSubmit} />
      </form>
    );
  }
}

const TargetingFiltersWrapper = (props) => {
  const { data } = useQueryNationalities();

  if (data?.length > 0) {
    return <TargetingFilters {...props} nationalityOptions={data} />;
  }

  return null;
};

TargetingFiltersWrapper.propTypes = {
  triggerSearch: PropTypes.func.isRequired,
  searchOnInit: PropTypes.bool.isRequired,
};

export default TargetingFiltersWrapper;
